import { GridSortDirection, GridSortModel } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';

// Use this hook to seed DataGrid's sortModel and onSortModelChange properties

export const useGridSort = (field: string, sort: 'asc' | 'desc') => {
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: field, sort: sort as GridSortDirection },
  ]);
  useEffect(() => {
    setSortModel([{ field: field, sort: sort as GridSortDirection }]);
  }, [field, sort]);
  const handleSortModelChange = (model: GridSortModel) => {
    if (model.length === 0)
      setSortModel([{ field: field, sort: sort as GridSortDirection }]);
    else if (
      sortModel.length === 0 ||
      model[0].field !== sortModel[0].field ||
      model[0].sort !== sortModel[0].sort
    )
      setSortModel(model);
  };
  return { sortModel, handleSortModelChange };
};
